import { Routes } from '@angular/router';
import { LoginComponent } from '@app/base/components/login/login.component';
import { AuthGuard } from '@app/base/helpers';
import { AplicativosComponent } from '@app/proyecto/components/aplicativos/aplicativos.component';

/* BASE */

/* PROJECT */
import { HomeComponent } from '@app/proyecto/components/home/home.component';

const appRoutes: Routes = [
    /* PROJECT */
    { path: '', component: AplicativosComponent },
    { path: 'login', component: LoginComponent },
    { path: 'aplicativos/:id', component: AplicativosComponent }
    /* BASE */
];

export default appRoutes;
